<template>
  <NoResults
    v-bind="{ illustration }"
    :alt="$t(`${translationBasePath}.alt`)"
    :button-text="isSelfExcluded ? undefined : $t(`${translationBasePath}.button.text`)"
    :headline="$t(`${translationBasePath}.headline`)"
    :subline="$t(`${translationBasePath}.subline`)"
    variant="outlined"
    @cta-click="navigateToPlayNow"
  />
</template>

<script lang="ts" setup>
type MyOrdersNoResultsProps = {
  variant: 'high-frequency' | 'scratchcard' | 'single-order' | 'subscription'
}

const { navigateToLocalized } = useRouterUtils()

const props = defineProps<MyOrdersNoResultsProps>()

const { result } = useUserStatusQuery({ fetchPolicy: 'cache-first' })

const illustration = computed(() => {
  if (props.variant === 'single-order') return 'no-single-orders'
  if (props.variant === 'subscription') return 'no-subscriptions'
  if (props.variant === 'high-frequency') return 'no-high-frequency-orders'
  return 'no-scratchcards'
})
const isSelfExcluded = computed(() => !!result.value?.player?.selfExclusion?.type)
const translationBasePath = computed(() => `myorders.tabs.${props.variant}.noresults`)

const navigateToPlayNow = () => {
  navigateToLocalized(props.variant === 'scratchcard' ? '/scratch' : '/')
}
</script>
